export const isEmpty = (obj: any) => {
  if (!obj) {
    return true;
  }
  if (Array.isArray(obj)) {
    return obj.length < 1;
  }
  if (typeof obj === "object") {
    return Object.keys(obj).length < 1;
  }
  return false;
};
